import type {Delivery} from "#magnolia-layer/types/api";
import type {Author} from "~/types/mgnl";
import {useMagnoliaFetch} from "#magnolia-layer/composables/use-magnolia-fetch";
import {joinURL} from "ufo";
import {useMagnoliaContext} from "#magnolia-layer/composables/use-magnolia-context";

export const useAuthor = async (
  ids: string[],
): Promise<Author[] | undefined> => {
  if (ids.length === 0) {
    return undefined;
  }

  const runtimeConfig = useRuntimeConfig();
  const authorIds = ids.join("%7c");

  const magnoliaContext = useMagnoliaContext();
  const baseURL: string = import.meta.server ? runtimeConfig.mgnl.host : runtimeConfig.public.mgnl.host;

  // We have to build our own url as using query will cause duplicate encoding regardless of useMagnoliaFetch or native useFetch causing %7C to be transformed back in to |
  const apiUrl: string = joinURL(baseURL, runtimeConfig.public.mgnl.apiAuthors, `?@jcr:uuid=${authorIds}&lang=${magnoliaContext.searchParams?.lang}`);

  const {data: content, error} = await useFetch<Delivery<Author>>(apiUrl);
  const results = content.value?.results || undefined;
  if (results && results.length > 0) {
    return results as Author[];
  }
  return undefined;
};
